module.exports = __webpack_public_path__ + "media/images/icons/spanner-icon-fcaa8235c21aec019d9c020367d10031.svg";